// drag_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["draggable", "dropzone", "ids"];

  connect() {
    this.setIds();
  }

  dragStart(event) {
    const uniqueId = `${event.currentTarget.dataset.id}_${Date.now()}`;
    event.dataTransfer.setData("text/plain", uniqueId);
    event.currentTarget.dataset.tempId = uniqueId;
    event.currentTarget.classList.add("dragging");
  }

  dragOver(event) {
    event.preventDefault();
    const draggable = this.element.querySelector(".dragging");
    if (draggable && event.currentTarget === this.dropzoneTarget) {
      const afterElement = this.getAfterElement(event.currentTarget, event.clientY);
      if (afterElement == null) {
        event.currentTarget.appendChild(draggable);
      } else {
        event.currentTarget.insertBefore(draggable, afterElement);
      }
    }
  }

  drop(event) {
    event.preventDefault();
    const uniqueId = event.dataTransfer.getData("text/plain");
    const draggable = this.element.querySelector(`[data-temp-id="${uniqueId}"]`);

    if (draggable) {
      draggable.classList.remove("dragging");
      delete draggable.dataset.tempId;
    }

    this.setIds();
  }

  remove(event) {
    event.preventDefault();
    const item = event.currentTarget.closest('[data-drag-target="draggable"]');
    item.remove();
    this.setIds();
  }

  // Helper method to determine where to insert the dragged item
  getAfterElement(container, y) {
    const draggableElements = [
      ...container.querySelectorAll('[data-drag-target="draggable"]:not(.dragging)'),
    ];

    return draggableElements.reduce(
      (closest, child) => {
        const box = child.getBoundingClientRect();
        const offset = y - box.top - box.height / 2;
        if (offset < 0 && offset > closest.offset) {
          return { offset: offset, element: child };
        }
        return closest;
      },
      { offset: Number.NEGATIVE_INFINITY }
    ).element;
  }

  setIds() {
    if (this.hasIdsTarget) {
      this.idsTarget.value = JSON.stringify(
        Array.from(this.dropzoneTarget.children).map((child) => child.dataset.id)
      );
    }
  }
}
